// Tag Manager Component

import api from '../api.js';
import { loadTags } from './BookmarkList.js';

export function renderTagManager() {
  return `
    <div class="modal" id="tag-modal">
      <div class="modal-content">
        <div class="modal-header">
          <h2>Tags verwalten</h2>
          <button class="modal-close" id="close-tag-modal">&times;</button>
        </div>

        <div class="tag-manager">
          <div class="tag-form">
            <h3>Neuer Tag</h3>
            <form id="tag-form" class="form">
              <div class="form-row">
                <div class="form-group flex-grow">
                  <input
                    type="text"
                    id="tag-name"
                    name="name"
                    required
                    placeholder="Tag-Name"
                  >
                </div>
                <button type="submit" class="btn btn-primary">Erstellen</button>
              </div>
            </form>
          </div>

          <div class="tag-list" id="tag-list-manager">
            <h3>Bestehende Tags</h3>
            <div id="tag-items"></div>
          </div>
        </div>
      </div>
    </div>
  `;
}

export async function initTagManager() {
  const form = document.getElementById('tag-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    await createTag();
  });

  document.getElementById('close-tag-modal')?.addEventListener('click', closeTagManager);

  document.getElementById('tag-modal')?.addEventListener('click', (e) => {
    if (e.target.id === 'tag-modal') {
      closeTagManager();
    }
  });

  await renderTagItems();
}

async function renderTagItems() {
  try {
    const tags = await api.getTags();
    const container = document.getElementById('tag-items');
    if (!container) return;

    if (tags.length === 0) {
      container.innerHTML = '<p class="text-muted">Noch keine Tags vorhanden.</p>';
      return;
    }

    container.innerHTML = tags.map(tag => `
      <div class="tag-item" data-id="${tag.id}">
        <span class="tag-name">${escapeHtml(tag.name)}</span>
        <div class="tag-actions">
          <button class="btn-icon delete-tag" data-id="${tag.id}" title="Löschen">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            </svg>
          </button>
        </div>
      </div>
    `).join('');

    // Attach delete listeners
    container.querySelectorAll('.delete-tag').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        const id = parseInt(e.currentTarget.dataset.id);
        await deleteTag(id);
      });
    });
  } catch (error) {
    console.error('Failed to render tags:', error);
  }
}

async function createTag() {
  const form = document.getElementById('tag-form');
  const formData = new FormData(form);

  const data = {
    name: formData.get('name'),
  };

  try {
    await api.createTag(data);
    showSuccess('Tag erstellt');
    form.reset();
    await renderTagItems();
    await loadTags();
  } catch (error) {
    console.error('Failed to create tag:', error);
    showError('Fehler beim Erstellen: ' + error.message);
  }
}

async function deleteTag(id) {
  if (!confirm('Möchten Sie diesen Tag wirklich löschen? Er wird von allen Lesezeichen entfernt.')) {
    return;
  }

  try {
    await api.deleteTag(id);
    showSuccess('Tag gelöscht');
    await renderTagItems();
    await loadTags();
  } catch (error) {
    console.error('Failed to delete tag:', error);
    showError('Fehler beim Löschen: ' + error.message);
  }
}

function closeTagManager() {
  const modal = document.getElementById('tag-modal');
  if (modal) {
    modal.remove();
  }
}

function escapeHtml(text) {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

function showError(message) {
  const event = new CustomEvent('show-notification', {
    detail: { type: 'error', message }
  });
  document.dispatchEvent(event);
}

function showSuccess(message) {
  const event = new CustomEvent('show-notification', {
    detail: { type: 'success', message }
  });
  document.dispatchEvent(event);
}
